import React from "react";

import Icon from "assets/brain-hq-data.png";
import BGCInfoPage from "./BGCInfoPage";

const PageThree: React.FC = () => (
  <BGCInfoPage
    icon={Icon}
    iconAlt="BGC data and privacy icon"
    iconWidth={310}
    heading="How is my data being used and protected?"
  >
    You will enter a unique code to access the app and complete the assessments.
    Data collected in the BGC Science App is de-identified. BGC Science Team
    will share your data with the UT Dallas team, and we we will link it with
    your BrainHealth Index for analysis.
    <br />
    <br />
    <span style={{ fontWeight: 550 }}>Note:</span> This is optional and your
    choice will not affect your experience in the BrainHealth Project study.
  </BGCInfoPage>
);

export default PageThree;
